APPS.shows.episode = (function(){
    var show = function(showId,episodeId){
        APP.getView().showChildView('mainRegion',Backbone.Radio.channel('views').request('loading'))
       
        $.when( Backbone.Radio.channel('entities').request('episode',episodeId) ).done(function(episodeData){
            if(episodeData.attributes.error === "No episodes found"){
		        //we should have a showId/slug, so kick them to the program page
		        Backbone.Radio.channel('shows').request("show",showId);
		    }else{            
	            $.when( Backbone.Radio.channel('entities').request('show',episodeData.attributes.showid) ).done(function(showData){ 
					if(showData.attributes.type==="radio"){
						APP.getView().showChildView('mainRegion', Backbone.Radio.channel('views').request('show-radio',{
							/* This actually calls a Radio Program page, so pass the program as the main content 
								and the episode as secondary */
							 model : showData	
							,attributes:{ episode:episodeData}
							, is_epi_page: true
			    		}));
			    	}else{ //tv
				    	var slug = showData.attributes.slug; // This is to check Shows that have collections or not 
						APP.getView().showChildView('mainRegion', Backbone.Radio.channel('views').request('show-tv-episode',{
							 model : episodeData
							 //pass in show metadata 
							,attributes:{ program:showData, slug: slug }
						}) )
			    	}
			    	
			    	window.document.title = showData.attributes.title+": "+episodeData.attributes.title;
					if(typeof ga != "undefined"){ ga('send','pageview',{ title: showData.attributes.title+": "+episodeData.attributes.title }) }
					if(typeof gtag != "undefined"){ gtag('event', 'page_view', { 'page_title': showData.attributes.title+": "+episodeData.attributes.title }); }
					if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, showData.attributes.title+": "+episodeData.attributes.title, '0', false, true); }
		        })
	        }
        })
    }
   
    return {
        show:show
    }
})();
